export default "__VITE_ASSET__BGKIn2uj__"